import { Maybe } from 'graphql/jsutils/Maybe';
import { GetCabinaQuery } from '../../_graphql/generated';

export type CabinaState = {
  loading: boolean;
  lista: GetCabinaQuery['energy_village_cabina'];
  failure: any;
};

export const initialGetCabinaState: CabinaState = {
  loading: false,
  lista: [],
  failure: '',
};
